export default "__VITE_ASSET__CFR2DPnA__"